import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
  type CollectionReference,
  type DocumentData,
} from "firebase/firestore";

import { db } from "@/apis/config/firebase";
import type { IMachineLicense, LicenseStatus } from "@/features/licenses/schemas/license";

const LICENSES_COLLECTION = "licenses";

function getLicensesCollection(): CollectionReference<DocumentData> {
  return collection(db, LICENSES_COLLECTION);
}

export async function getLicensesByUser(userId: string): Promise<IMachineLicense[]> {
  const licensesRef = getLicensesCollection();
  const q = query(licensesRef, where("userId", "==", userId));
  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => ({
    licenseId: doc.id,
    ...doc.data(),
  })) as IMachineLicense[];
}

export async function getLicensesByMachine(
  userId: string,
  machineId: string
): Promise<IMachineLicense[]> {
  const licensesRef = getLicensesCollection();
  const q = query(
    licensesRef,
    where("userId", "==", userId),
    where("machineId", "==", machineId)
  );
  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => ({
    licenseId: doc.id,
    ...doc.data(),
  })) as IMachineLicense[];
}

export async function createLicense(license: IMachineLicense): Promise<void> {
  const licenseRef = doc(db, LICENSES_COLLECTION, license.licenseId);
  await setDoc(licenseRef, license);
}

export async function deleteLicense(licenseId: string): Promise<void> {
  const licenseRef = doc(db, LICENSES_COLLECTION, licenseId);
  await deleteDoc(licenseRef);
}

export async function updateLicenseStatus(
  licenseId: string,
  status: LicenseStatus
): Promise<void> {
  const licenseRef = doc(db, LICENSES_COLLECTION, licenseId);
  await updateDoc(licenseRef, { status });
}
